import { config } from '../config';

const COGNITO_KEY_PREFIX = 'CognitoIdentityServiceProvider.';

const decodeBase64Url = (value) => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
  return decodeURIComponent(
    window.atob(padded)
      .split('')
      .map((character) => `%${character.charCodeAt(0).toString(16).padStart(2, '0')}`)
      .join('')
  );
};

const getStoredIdToken = () => {
  if (typeof window === 'undefined' || !config?.cognito?.APP_CLIENT_ID) return null;

  try {
    const storage = window.localStorage;
    const clientKeyPrefix = `${COGNITO_KEY_PREFIX}${config.cognito.APP_CLIENT_ID}.`;
    const lastAuthUser = storage.getItem(`${clientKeyPrefix}LastAuthUser`);
    if (!lastAuthUser) return null;

    return storage.getItem(`${clientKeyPrefix}${lastAuthUser}.idToken`);
  } catch (_error) {
    return null;
  }
};

export const hasStoredCognitoSession = () => Boolean(getStoredIdToken());

/**
 * Returns only non-sensitive identity hints needed to filter the cold-start
 * command palette. The token is still validated by Amplify before App renders
 * any protected destination.
 */
export const getCachedCognitoUser = () => {
  const idToken = getStoredIdToken();
  if (!idToken) return null;

  try {
    const [, encodedPayload] = idToken.split('.');
    if (!encodedPayload) return null;

    const payload = JSON.parse(decodeBase64Url(encodedPayload));
    const role = payload['custom:currentUserRole'];
    if (!role) return null;

    return {
      id: payload.sub,
      role,
      email: payload.email,
      firstName: payload.given_name,
      lastName: payload.family_name,
      customerId: payload['custom:qflowCustomerId'],
      homeCustomerId: payload['custom:qflowCustomerId'],
    };
  } catch (_error) {
    return null;
  }
};
